<template>
    <v-layout row wrap>
      <v-flex xl9 lg8 md8 sm12 xs12>
        <div style="height:60px" class="hidden-md-and-up"></div>
        <Carousel />
        <Descripcion />
        <Extra :horizontal="true" class="hidden-xs-and-down"/>
      </v-flex>
      <v-flex xl3 lg4 md4 sm12 xs12>
        <NoticiasFacebook />
        <br/>
        <Extra :horizontal="false" class="hidden-md-and-up"/>
      </v-flex>
    </v-layout>    
 
</template>
<script>
import Carousel from "@/components/Inicio/Carousel";
import NoticiasFacebook from '@/components/Inicio/NoticiasFacebook';
import Descripcion from '@/components/Inicio/Descripcion';
import Extra from '@/components/Inicio/Extra';
export default {
  components: { Carousel ,NoticiasFacebook,Descripcion,Extra},
  mounted(){
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
<style>
.item {
  margin: 10px;
}
.datos-numericos {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 5px;
}
.texto-descripcion {
  font-size: 1rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Inicio/index.vue